import * as S from "./styles.ts";
import { CSSProperties, ReactNode } from "react";

type HTMLDiv = typeof HTMLDivElement;

export interface ISkeletonProps extends Partial<HTMLDiv> {
  children?: ReactNode;
  hideSkeleton?: boolean;
  opaque?: boolean;
  style?: CSSProperties;
}

export const Skeleton = ({
  children,
  hideSkeleton,
  opaque,
  style,
  ...props
}: ISkeletonProps) => {
  if (hideSkeleton) return children;
  return (
    <S.SkeletonWrapper
      $opaque={opaque}
      style={style}
      {...props}
    >
      {children}
    </S.SkeletonWrapper>
  );
};

export default Skeleton;
